import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ClusterUidAndName } from '@shared/models/cluster';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cluster-selector',
  templateUrl: './cluster-selector.component.html',
  styleUrls: ['./cluster-selector.component.scss'],
  imports: [FormsModule, NgSelectComponent],
})
export class ClusterSelectorComponent<T extends ClusterUidAndName> implements OnChanges {
  @Input() clusters: T[];
  @Input() cluster: T;
  @Output() selected = new EventEmitter<T>();

  constructor(public translate: TranslateService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['clusters'] && this.clusters?.length && !this.cluster) {
      this.cluster = this.clusters[0];
      this.selected.emit(this.cluster);
    }
  }

  compareCluster = (a: T, b: T) => a?.uid === b?.uid;

  selectCluster(cluster: T) {
    return this.selected.emit(cluster);
  }
}
